import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-general-data',
  templateUrl: './general-data.component.html',
  styleUrls: ['./general-data.component.scss']
})
export class GeneralDataComponent implements OnInit, AfterViewInit {

  @Input()
  criticalityTypes = [];

  @Input()
  alertEntity:string;

  @Input()
  criticalityId:number;

  @Input() editable: boolean;

  @Output()
  formGeneralData: EventEmitter<ComplaintFormGeneralData> = new EventEmitter<ComplaintFormGeneralData>();
  
  form: UntypedFormGroup;

  maxLength: number = 1024;

  entityInputLenght: number = 0;

  constructor(
    private formBuilder: UntypedFormBuilder,
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      criticalityTypeId: this.criticalityId,
      entityAlertBelongs: this.alertEntity
    });
    this.entityInputLenght = this.form.get('entityAlertBelongs').value?.length;
    this.form.valueChanges.subscribe(
      changes => {
        this.formGeneralData.emit(changes);
        this.entityInputLenght = this.form.get('entityAlertBelongs').value?.length;
        if(this.form.get('criticalityTypeId').value > 1){
          this.form.controls['criticalityTypeId'].setErrors({'required': null});
        }
        // if(this.form.get('entityAlertBelongs').value){
        //   this.form.controls['entityAlertBelongs'].setErrors({'required': null});
        //   this.form.get('entityAlertBelongs').hasError('required')
        // }
        // if(this.form.get('entityAlertBelongs').value?.length < this.maxLength){
        //   this.form.controls['entityAlertBelongs'].setErrors({'maxLength': null});
        // }
      }
    )
  }

  ngAfterViewInit() {
    this.form.disable({emitEvent: false});
    if (this.editable) {
      this.form.enable({emitEvent: false});
    }
  }

  onSetErrors(){
    // console.log(this.form.value);
    if(this.form.get('criticalityTypeId').value < 1){
      this.form.controls['criticalityTypeId'].setErrors({'required': true});
    }
    if(!this.form.get('entityAlertBelongs').value){
      this.form.controls['entityAlertBelongs'].setErrors({'required': true});
    }
    if(this.form.get('entityAlertBelongs').value?.length > this.maxLength){
      this.form.controls['entityAlertBelongs'].setErrors({'maxLength': true});
    }
  }
}

export interface ComplaintFormGeneralData{
  criticalityTypeId: number;
  entityAlertBelongs: string;
}
